require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./danove-poradenstvi.json") })
        }
      }, "path---danove-poradenstvi");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---danove-poradenstvi!./.cache/json/danove-poradenstvi.json
// module id = 409
// module chunks = 231608221292675